// import React from "react";

// export default function BuyModal({
//   numbers = [],
//   price = 0,
//   onClose,
//   onConfirm,
//   balance = 0,
// }) {
//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-30">
//       <div className="bg-white rounded-2xl p-6 w-full max-w-sm shadow-2xl">
//         <h2 className="font-bold text-xl text-center mb-4">Confirm Purchase</h2>
//         <div className="mb-3 text-center text-gray-700">
//           You are buying <b>{numbers.length}</b> number(s): <br />
//           <span className="font-mono">{numbers.join(", ")}</span>
//         </div>
//         <div className="mb-2 text-center">
//           <span className="font-bold text-lg">
//             ${Number(price || 0).toFixed(2)}
//           </span>

//           <div className="text-sm text-gray-500">
//             Your balance: ${Number(balance || 0).toFixed(2)}
//           </div>
//         </div>
//         <div className="flex gap-3 mt-5">
//           <button
//             className="bg-slate-200 px-4 py-2 rounded-xl w-full"
//             onClick={onClose}
//           >
//             Cancel
//           </button>
//           <button
//             className="bg-gradient-to-r from-green-400 to-blue-500 text-white px-4 py-2 rounded-xl w-full font-bold"
//             onClick={() => onConfirm(numbers)}
//             disabled={balance < price}
//           >
//             Buy
//           </button>
//         </div>
//         {balance < price && (
//           <div className="text-red-500 text-xs mt-2 text-center">
//             Not enough balance
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

import React from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function BuyModal({
  numbers = [],
  price = 0,
  onClose,
  onConfirm,
  balance = 0,
}) {
  return (
    <AnimatePresence>
      <motion.div
        className="fixed inset-0 z-40 bg-black/70 flex justify-center items-center"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <motion.div
          className="bg-gradient-to-br from-white/95 to-slate-100 rounded-2xl p-8 w-full max-w-md shadow-2xl relative flex flex-col items-center"
          initial={{ scale: 0.9, opacity: 0.7 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.9, opacity: 0.5 }}
        >
          <button
            onClick={onClose}
            className="absolute right-4 top-4 text-slate-400 hover:text-black text-xl"
            title="Close"
          >
            ×
          </button>
          <h2 className="font-bold text-2xl text-center mb-3 text-gradient text-gray-700">
            🛒 Confirm Purchase
          </h2>

          <div className="mb-4 text-center text-gray-700 text-lg">
            You’re buying
            <span className="mx-2 font-extrabold text-blue-600 text-2xl">
              {numbers.length}
            </span>
            number{numbers.length > 1 ? "s" : ""}:
          </div>

          <div className="flex flex-wrap gap-2 mb-5 justify-center">
            {numbers.map((n, i) => (
              <span
                key={n}
                className="inline-block bg-gradient-to-br from-blue-400 to-green-400 text-white font-bold px-4 py-2 rounded-xl shadow text-lg"
              >
                {n}
              </span>
            ))}
          </div>

          <div className="w-full text-center mb-3">
            <div className="text-gray-500">Total Price</div>
            <div className="font-mono text-3xl font-bold text-green-600 mb-2">
              ${Number(price || 0).toFixed(2)}
            </div>
            <div className="text-gray-500">
              Your balance:{" "}
              <span className="font-semibold text-slate-800">
                ${Number(balance || 0).toFixed(2)}
              </span>
            </div>
          </div>

          <div className="flex gap-4 mt-6 w-full">
            <button
              className="flex-1 bg-slate-200 text-slate-700 font-bold py-3 rounded-xl hover:bg-slate-300 transition"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              className={`flex-1 bg-gradient-to-br from-green-400 to-blue-500 text-white font-bold py-3 rounded-xl transition shadow-xl
              ${
                balance < price
                  ? "opacity-50 cursor-not-allowed"
                  : "hover:from-green-500 hover:to-blue-600"
              }`}
              onClick={() => onConfirm(numbers)}
              disabled={balance < price}
            >
              Buy Now
            </button>
          </div>

          {balance < price && (
            <div className="text-red-500 text-xs mt-3 font-bold animate-pulse text-center">
              Not enough balance
            </div>
          )}
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}
